import { Page } from 'components/Page/Page';
import { Button } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import {
  StreamingStatusFormData,
  StreamingStatusFormModelData
} from './StreamingStatusFormModel';
import i18n from 'i18n';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import { useCallback } from 'react';
import { Form } from 'components/common/form/Form';
import { Formik, FormikProps } from 'formik';
import { StreamingStatusDTO } from 'core/streamingStatus/StreamingStatus';
import { FormikField } from 'components/common/form/field/FormikField';

type StreamingStatusFormProps = {
  streamingStatusList: StreamingStatusDTO[];
  useModel: (
    streamingStatusList: StreamingStatusDTO[]
  ) => StreamingStatusFormModelData;
};

export const StreamingStatusForm: React.FC<StreamingStatusFormProps> = ({
  streamingStatusList,
  useModel
}) => {
  const {
    loading,
    title,
    isEditing,
    redirectPathData,
    initFormData,
    submit,
    cancel
  } = useModel(streamingStatusList);

  const renderBtns = useCallback(
    () => (
      <>
        <Button variant='primary' size='sm' type='submit'>
          {i18n.t('common.buttons.submit')}
        </Button>
        <Button variant='secondary' size='sm' onClick={cancel}>
          {i18n.t('common.buttons.cancel')}
        </Button>
      </>
    ),
    [cancel]
  );

  const renderForm = useCallback(
    (formikProps: FormikProps<StreamingStatusFormData>) => {
      return (
        <Form formikProps={formikProps} renderFormBtns={renderBtns}>
          {isEditing ? (
            <FormikField.Label
              label={i18n.t('streamingStatusForm.labels.crid')}
              name='crid'
            />
          ) : (
            <FormikField.Input
              label={i18n.t('streamingStatusForm.labels.crid')}
              name='crid'
            />
          )}
          <FormikField.Switch
            label={i18n.t('streamingStatusForm.labels.isLive')}
            name='isLive'
          />
        </Form>
      );
    },
    [isEditing, renderBtns]
  );

  if (redirectPathData) {
    return <Redirect to={redirectPathData} />;
  }

  if (!initFormData) {
    return <LoadingIndicator />;
  }

  return (
    <div style={{ height: '100%' }}>
      {loading && <LoadingIndicator />}
      <Page title={title}>
        <Formik initialValues={initFormData} onSubmit={submit}>
          {renderForm}
        </Formik>
      </Page>
    </div>
  );
};
